<template>
  <div class="public-content customer-info">
    <div class="breadcrumb">客户信息</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="手机号:">
              <el-input v-model="formInline.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="业务:">
              <el-input v-model="formInline.salesmanName" placeholder="请输入业务名"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="平台号:">
              <!-- <el-input v-model="formInline.storeCode" placeholder="请输入平台号"></el-input> -->
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <!-- <el-input v-model="formInline.storeName" placeholder="请输入平台名称"></el-input> -->
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户类型:">
              <el-select v-model="formInline.userType" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option :label="item.name" :value="item.userType" v-for="item in userList" :key="item.userType"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册日期:" class="el-date-width">
              <el-date-picker clearable v-model="value2" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"
                :picker-options="pickerOptions" format="yyyy - MM - dd " value-format="yyyy-MM-dd" @change="changeDate">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, getCustomerInfo(queryInfo)" round>查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="手机号" min-width="10px">
            <template v-slot="scope">
              <!-- <router-link v-if="$hasPermission('crm:admin:user:update')" :to="{ path: './customerdetails', query: { id: scope.row.id } }" class="color-blue"> {{ scope.row.phone }}</router-link> -->
              <span v-if="$hasPermission('crm:admin:user:update')" @click="toInfo(scope.row)" class="color-blue">{{ scope.row.phone }}</span>
              <span v-else>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="fullName" label="客户姓名" min-width="10px"></el-table-column>
          <el-table-column prop="storeCode" label="平台号" min-width="10"></el-table-column>
          <el-table-column prop="storeName" label="平台名称" min-width="10"></el-table-column>
          <!-- <el-table-column prop="salesmanName" label="业务" min-width="10"></el-table-column> -->
          <el-table-column prop="typeName" label="客户类型" min-width="10"></el-table-column>
          <el-table-column prop="registerTime" label="注册日期" min-width="10"></el-table-column>
          <el-table-column v-if="$hasPermission('crm:admin:user:update')" label="操作" min-width="10px">
            <template v-slot="scope">
              <!-- <router-link :to="{
                path: './customerdetails',
                query: {
                  id: scope.row.id
                }
              }" class="color-blue">{{ scope.row.operation }}</router-link> -->
              <span @click="toInfo(scope.row)" class="color-blue">{{ scope.row.operation }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { userGetUserList, userGetUserTypeList, userGetUserType, storeQueryListByCode, storeQueryListByName } from '@/api/crm'
export default {
  name: 'customer-info',
  components: {
    VPagination
  },
  data () {
    return {
      storeListByCode: [],
      formInline: {
        storeId: '',
        phone: '',
        salesmanName: '',
        // storeCode: '',
        // storeName: '',
        registerTimeBegin: '',
        registerTimeEnd: '',
        userType: ''
      },
      tableData: [],
      value2: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      userList: [],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.value2 = [this.formInline.registerTimeBegin, this.formInline.registerTimeEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    // 获取用户列表
    this.getCustomerInfo(this.queryInfo)
    // 获取用户类型
    this.getUserGetUserTypeList()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    toInfo (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      this.$router.push({ path: './customerdetails', query: { id: row.id } })
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    getUserGetUserTypeList () {
      userGetUserType().then(res => {
        this.userList = res.data.data
      })
    },
    getCustomerInfo (val) {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      }
      userGetUserList({ pageNum: val.pageNum, pageSize: val.pageSize, userVo: this.formInline }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.records.map(a => {
            a.phone = this.$msg.filterBridal(a.phone)
            return a
          })
          this.queryInfo.total = res.data.data.total
          this.tableData.forEach((item) => {
            item.operation = '设置'
          })
        }
      })
    },
    getUserType () {
      userGetUserTypeList(1).then((res) => {
        if (res.data.success) {
          this.userList = res.data.data
        }
      })
    },
    changeDate (val) {
      if (val) {
        this.formInline.registerTimeBegin = val[0]
        this.formInline.registerTimeEnd = val[1]
      } else {
        this.formInline.registerTimeBegin = ''
        this.formInline.registerTimeEnd = ''
      }
    },
    changePage (val) {
      this.queryInfo = val
      this.getCustomerInfo(this.queryInfo)
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
